import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { AuthProvider } from './context/AuthContext.jsx';
import { Elements } from '@stripe/react-stripe-js'; // Import Elements
import { loadStripe } from '@stripe/stripe-js'; // Import loadStripe

// Load Stripe outside of a component’s render to avoid
// recreating the Stripe object on every render.
// Use your Stripe publishable key from environment variables.
const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <Elements stripe={stripePromise}> {/* Wrap App with Elements */}
        <App />
      </Elements>
    </AuthProvider>
  </React.StrictMode>,
);
